import React, { useEffect, useState } from "react";
import "../../style.css";
import { RxCrossCircled } from "react-icons/rx";
import { CButton } from "@coreui/react";
import { editProfile, getProfile } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { MdVerifiedUser } from "react-icons/md";
import { MdOutlineLockReset } from "react-icons/md";
import EditProfileModal from "./EditProfileModal";
import ChangePasswordModal from "./ChangePasswordModal";
import { EditProfileSchema } from "../../../utils/validationSchema";
import { useFormik } from "formik";
import CustomInputField from "../../../components/customInputField";
import { uploadFileToS3, uploadSiteImage } from "../../sites/action";
import ProfileImageUpload from "../../../components/profileImgUpload";
import ProperSpinner from "../../../components/spinner/ProperSpinner";

const Profile = () => {
  const dispatch = useDispatch();
  const [showChangnePasswordModal, setShowChangePasswordModal] =
    useState(false);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [file, setFile] = useState();
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const fileHandler = (data) => {
    setFile(data);
  };
  const imageUrlHandler = (data) => {
    setImageUrl(data);
  };

  const showEditProfileModalHandler = () => {
    setShowEditProfileModal(!showEditProfileModal);
  };
  const showChangnePasswordModalHandler = () => {
    setShowChangePasswordModal(false);
  };

  const { adminDetails: profileDetails, isLoading } = useSelector(
    (state) => state.AuthReducer
  );

  const getImageCrediantial = () => {
    dispatch(
      uploadSiteImage(
        {
          folderType: 4,
          files: [file.name],
        },
        (response) => {
          if (!response) {
            setLoading(false);
          } else uploadFileToS3Hanlder(response.data);
        }
      )
    );
  };

  const uploadFileToS3Hanlder = async (fileResponses) => {
    dispatch(
      uploadFileToS3(file, fileResponses[0], (response) => {
        if (response.isSuccess) {
          setImageUrl((prev) => response.imageUrl);
          updateProfileHandler(response);
        } else {
          setLoading(false);
        }
      })
    );
  };
  const updateProfileHandler = (profilePicUrl) => {
    const payload = {
      ...editProfileData.values,
      profileImage: profilePicUrl.imageUrl,
    };
    dispatch(
      editProfile(payload, () => {
        dispatch(
          getProfile((response) => {
            if (response) {
              setImageUrl(response?.data?.profileImage);
            }
            setLoading(false);
          })
        );
        setLoading(false);
      })
    );
  };

  const initialValues = {
    firstName: profileDetails?.firstName,
    lastName: profileDetails?.lastName,
    phoneNo: profileDetails?.phoneNo,
  };

  const editProfileData = useFormik({
    initialValues: initialValues || editProfileInitialValues,
    enableReinitialize: true,
    validationSchema: EditProfileSchema,
    onSubmit: (values, actions) => {
      setLoading(true);
      if (file) {
        getImageCrediantial();
      } else {
        updateProfileHandler(imageUrl);
      }
    },
  });

  useEffect(() => {
    setLoading(true);
    dispatch(
      getProfile((response) => {
        setImageUrl(response?.data?.profileImage);
        setLoading(false);
      })
    );
  }, []);

  const renderView = () => {
    return (
      <div className="user-details-main-container">
        {loading && <ProperSpinner />}
        <div className="user-details-container-1 ">
          <div className="profile-img-upload-container">
            <ProfileImageUpload
              files={file}
              filesHandler={fileHandler}
              imageUrl={imageUrl}
              imageUrlHandler={imageUrlHandler}
            />
          </div>
          <p className="label-text email-text">
            {profileDetails?.email || "N/A"}
          </p>
          <div className="btn-container mt-2">
            <div
              className={`d-flex justify-content-center  align-items-center gap-1 user-details-btns ${profileDetails?.profileCompleted ? "success-btn" : "warning-btn"}`}
            >
              {"Profile Completed"}
              {profileDetails?.profileCompleted ? (
                <MdVerifiedUser />
              ) : (
                <RxCrossCircled />
              )}
            </div>
            <div
              onClick={() => setShowChangePasswordModal(true)}
              className={`d-flex justify-content-center  align-items-center gap-1 user-details-btns user-details-clickable-btns `}
            >
              {"Change Password"}
              <MdOutlineLockReset className="user-details-icons" />
            </div>
          </div>
        </div>
        <div className="user-details-container-2 ">
          {/* Profile Section */}
          <div className="personal-info-container">
            <h4 className="label-text heading text-underline ">
              {"Personal Information"}
            </h4>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <CustomInputField
                  label={"First Name *"}
                  changeHandler={editProfileData?.handleChange}
                  placeholderText={"Enter first name"}
                  value={editProfileData?.values.firstName}
                  name={"firstName"}
                />
                {editProfileData?.errors.firstName &&
                  editProfileData?.touched.firstName && (
                    <div className="change-password-error">
                      {editProfileData?.errors.firstName}
                    </div>
                  )}
              </div>
              <div className="info-sub-child-container">
                <CustomInputField
                  label={"Last Name *"}
                  changeHandler={editProfileData?.handleChange}
                  placeholderText={"Enter last name"}
                  value={editProfileData?.values.lastName}
                  name={"lastName"}
                />
                {editProfileData?.errors.lastName &&
                  editProfileData?.touched.lastName && (
                    <div className="change-password-error">
                      {editProfileData?.errors.lastName}
                    </div>
                  )}
              </div>
            </div>
            <div>
              <p className="non-label-text">{"Email Address"}</p>
              <p className="label-text info-text">
                {profileDetails?.email}{" "}
                <CButton
                  size="sm"
                  disabled
                  color={profileDetails?.emailVerify ? "success" : "warning"}
                  variant="outline"
                  shape="rounded-pill"
                  className="d-flex justify-content-center  align-items-center gap-1 verification-btn"
                >
                  {"Email Verified"}
                  {profileDetails?.emailVerify ? (
                    <MdVerifiedUser />
                  ) : (
                    <RxCrossCircled />
                  )}
                </CButton>
              </p>
            </div>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <CustomInputField
                  label={"Phone Number *"}
                  changeHandler={editProfileData?.handleChange}
                  placeholderText={"Enter mobile number"}
                  value={editProfileData?.values.phoneNo}
                  name={"phoneNo"}
                />
                {editProfileData?.errors.phoneNo &&
                  editProfileData?.touched.phoneNo && (
                    <div className="change-password-error">
                      {editProfileData?.errors.phoneNo}
                    </div>
                  )}
              </div>
              <div className="info-sub-child-container">
                <p className="non-label-text">{"DOB"}</p>
                <p className="label-text info-text">
                  {profileDetails?.dateOfBirth || "N/A"}
                </p>
              </div>
            </div>

            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Country Code"}</p>
                <p className="label-text info-text">
                  {profileDetails?.countryCode || "N/A"}
                </p>
              </div>
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Country"}</p>
                <p className="label-text info-text">
                  {profileDetails?.country || "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="update-site-bottom-btn-container mt-5">
            <button
              disabled={
                JSON.stringify(initialValues) ===
                  JSON.stringify(editProfileData.values) && !file
              }
              type="submit"
              className="btn btn-primary  user-details-btns mt-5"
              onClick={editProfileData.handleSubmit}
            >
              {"Save"}
            </button>
          </div>
        </div>

        <ChangePasswordModal
          visible={showChangnePasswordModal}
          visibleHandler={showChangnePasswordModalHandler}
        />
        <EditProfileModal
          visible={showEditProfileModal}
          visibleHandler={showEditProfileModalHandler}
        />
      </div>
    );
  };
  return <>{isLoading ? <ProperSpinner /> : renderView()}</>;
};

export default Profile;
